// extracted by mini-css-extract-plugin
export default {"aucNav":"tabs_aucNav__rd-6r","aucNavItem":"tabs_aucNavItem__VehBp","activeNavItem":"tabs_activeNavItem__Wrfek"};